import React, { useEffect } from 'react';
import { render } from 'react-dom';
import { InertiaApp } from '@inertiajs/inertia-react';
import { InertiaProgress } from '@inertiajs/progress';
import * as Sentry from '@sentry/browser';
import { Inertia } from '@inertiajs/inertia';
import './Libs/Iframe.js';
import 'react-tooltip/dist/react-tooltip.css';
import {
  InertiaVisitProvider,
  useCanNavigate
} from './Context/InertiaVisitEnabled.js';
import useSessionHeartbeat from './Libs/useSessionHeartbeat.js';
import { NotesProvider } from './Context/NotesContext.js';

InertiaProgress.init({
  color: '#ED8936',
  showSpinner: true
});

Sentry.init({
  dsn: process.env.MIX_SENTRY_LARAVEL_DSN
});

const InertiaAppWrapper = () => {
  const { canNavigate, setCanNavigate, navigateMessage } = useCanNavigate();

  useSessionHeartbeat();

  useEffect(() => {
    const handleBefore = event => {
      if (!canNavigate) {
        alert(navigateMessage);
        event.preventDefault();
      }
    };

    return Inertia.on('before', handleBefore);
  }, [canNavigate, navigateMessage]);

  useEffect(() => {
    // When a user goes back allow page navigation
    const handlePopState = () => {
      setCanNavigate(true);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  });

  const app = document.getElementById('app');

  return (
    <InertiaApp
      initialPage={JSON.parse(app.dataset.page)}
      resolveComponent={name =>
        import(`./Pages/${name}`).then(module => module.default)
      }
    />
  );
};

const app = document.getElementById('app');

render(
  <InertiaVisitProvider>
    <NotesProvider>
      <InertiaAppWrapper />
    </NotesProvider>
  </InertiaVisitProvider>,
  app
);
